import React, { forwardRef, useRef, useImperativeHandle } from "react";

import { useIntersect } from "hooks/useIntersect";
import { a, SpringValue } from "@react-spring/web";
import { useAnimateInTrail } from "hooks/useAnimateInTrail";
import { initialOffset } from "components/Animations/SpringProperties/SpringProperties";

import * as fromProjects from "store/Projects";

import { Icon } from "components/Icon/Icon";

interface IProps {
  animationReady: boolean;
  bulletPoints: fromProjects.IBulletPoints;
}

const ProjectBulletListComponent: React.FC<IProps> = ({
  animationReady,
  bulletPoints,
  ...props
}) => {
  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
    rootMargin: "-150px 0px -150px 0px",
  });

  const [animateInTrail] = useAnimateInTrail(inView, bulletPoints.list.length);

  const listStyles = (index: number) => ({
    opacity: animateInTrail[index].active,
    transform: animateInTrail[index].active.to(
      (x) => `translateX(calc(${initialOffset(x)}))`
    ),
  });

  const getBulletPoints = () =>
    bulletPoints.list.map((bulletpoint, index) => {
      return (
        <a.li key={index} style={listStyles(index)}>
          <div className={"serviceIcon"}>
            <Icon type={bulletpoint.icon} color={bulletPoints.color} />
          </div>
          {bulletpoint.label}
        </a.li>
      );
    });

  return (
    <div>
      <ul ref={inViewRef}>{getBulletPoints()}</ul>
    </div>
  );
};

export const ProjectBulletList = ProjectBulletListComponent;
